import _slicedToArray from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { createUseExternalEvents } from '@mantine/utils';

var _createUseExternalEve = createUseExternalEvents("mantine-modals"),
    _createUseExternalEve2 = _slicedToArray(_createUseExternalEve, 2),
    useModalsEvents = _createUseExternalEve2[0],
    createEvent = _createUseExternalEve2[1];

var openModal = createEvent("openModal");
var closeModal = createEvent("closeModal");
var closeAllModals = createEvent("closeAllModals");
var openConfirmModal = createEvent("openConfirmModal");

var openContextModal = function openContextModal(payload) {
  return createEvent("openContextModal")(payload);
};

var modals = {
  open: openModal,
  close: closeModal,
  closeAll: closeAllModals,
  openConfirmModal,
  openContextModal
};
export { closeAllModals, closeModal, createEvent, modals, openConfirmModal, openContextModal, openModal, useModalsEvents };